var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatMute = function SvgChatMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M22.01 0H2C.9 0 0 .9 0 2v14.42c0 1.1.9 2 2 2h12.886l1.2 1.55h.01l3.442 3.94c.16.18.46.07.46-.17v-5.32H22c1.1 0 2.001-.9 2.001-2V2c.01-1.1-.89-2-1.99-2Zm-6.193 11.6a.996.996 0 0 1-.71 1.7c-.26 0-.51-.1-.711-.29l-2.401-2.41-2.411 2.41a.997.997 0 1 1-1.41-1.41l2.4-2.41-2.4-2.41a.997.997 0 1 1 1.41-1.41l2.411 2.41 2.401-2.41a.997.997 0 1 1 1.41 1.41l-2.41 2.41 2.41 2.41h.01Z"
  })));
};
export default SvgChatMute;